// extracted by mini-css-extract-plugin
module.exports = {"logo":"header-logo-module--logo--7xnOm"};